import dayjs from 'dayjs';
import { useState } from 'react';
import { stringOrDate } from 'react-big-calendar';

export function useCalendarRange(initialStart: Date, initialEnd: Date) {
  const [startOn, setStartOn] = useState<Date>(initialStart);
  const [endOn, setEndOn] = useState<Date>(initialEnd);

  const onRangeChange = (
    range:
      | Date[]
      | {
          start: stringOrDate;
          end: stringOrDate;
        }
  ) => {
    // Day/week view is an array of dates, so the end date is the last item in the array.
    if (Array.isArray(range)) {
      setStartOn(dayjs(range[0]).startOf('day').toDate());
      setEndOn(
        dayjs(range[range.length - 1])
          .endOf('day')
          .toDate()
      );
    } else {
      // Month/agenda view is a dictionary with two keys, 'start' and 'end'
      setStartOn(dayjs(range.start).startOf('day').toDate());
      setEndOn(dayjs(range.end).endOf('day').toDate());
    }
  };

  return {
    startOn,
    endOn,
    onRangeChange
  };
}
